export default {
  // Charge
  department: '부서',
  monthUse: '사용 월',
  billingMonth: '청구 월',
  all: '전체',
  usePeriod: '사용기간',
  captionVAT: '* VAT포함 / 청구내역은 매월 5일경 업데이트',
  year: '년',
  month: '월',
  totalCharge: '총 청구금액',
  cost: '원',
  simpleCheck: '사용료 간략 확인',
  captionDetail: '* 세부사항은 하단 표 참고',
  msgCost: '1. 문자메시지 사용료',
  kakaoCost: '2. 카카오톡 비즈 메시지 사용료',
  fixedCost: '(월 고정비)',
  maintenanceCost: '4. 기본요금',
  useCost: '5. 사용요금',
  vatCost: '6. 부가세',
  monthTotalCost: '7. 이번 달 청구금액',
  alimtalk: '알림톡',
  att: '알림톡 텍스트',
  ati: '알림톡 이미지',
  ftt: '친구톡 텍스트',
  fti: '친구톡 이미지',
  ftw: '친구톡 와이드 이미지',
  msgCaption: '* 메시징 서비스 상품별 기본요금과 전송요금의 합계입니다.',
  kakaoCaption: '* 알림톡, 친구톡 기본요금과 전송요금의 합계입니다.',
  basicCaption: '* 기본요금 초과시 요금 부과',
  sendCost: '전송요금',
  totalSendCost: '전체발송건수',
  sendSuccess: '성공건수',
  unitCost: '단가',
  price: '금액',
  print: '인쇄하기',
  sms: 'SMS',
  lms: 'LMS',
  mms: 'MMS',
  '(1+2+3+4)': '(1+2+3+4)',
  '(5 * 10%)': '(5 * 10%)',
  '(5+6)': '(5+6)',

  // TODO
  yearUse: '사용 년도',
  maintenanceCostCaption: '* 아이투메시지 서비스 기본요금입니다.',
  rejectPhoneMaintenanceCost: '3. 080 수신거부 서비스 사용료',
  rejectPhoneMaintenanceCostCaption: '* 080 수신거부 번호 서비스 사용에 대한 기본요금입니다.',
};
